import { lazy } from 'react';

const ReceivedVerifierTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/verifier/consult/received-transfer',
			component: lazy(() => import('./ReceivedTransferContainer'))
		}
	]
};

export default ReceivedVerifierTransferConfig;


